/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersIdActivatePostRequest model module.
 * @module model/CustomersIdActivatePostRequest
 * @version 1.0.0
 */
class CustomersIdActivatePostRequest {
    /**
     * Constructs a new <code>CustomersIdActivatePostRequest</code>.
     * @alias module:model/CustomersIdActivatePostRequest
     */
    constructor() { 
        
        CustomersIdActivatePostRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomersIdActivatePostRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersIdActivatePostRequest} obj Optional instance to populate.
     * @return {module:model/CustomersIdActivatePostRequest} The populated <code>CustomersIdActivatePostRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersIdActivatePostRequest();

            if (data.hasOwnProperty('iccid')) {
                obj['iccid'] = ApiClient.convertToType(data['iccid'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersIdActivatePostRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersIdActivatePostRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['iccid'] && !(typeof data['iccid'] === 'string' || data['iccid'] instanceof String)) {
            throw new Error("Expected the field `iccid` to be a primitive type in the JSON string but got " + data['iccid']);
        }

        return true;
    }


}



/**
 * @member {String} iccid
 */
CustomersIdActivatePostRequest.prototype['iccid'] = undefined;






export default CustomersIdActivatePostRequest;

